module.exports = {"INF_PINK_ITEM_1":"","INF_PINK_ITEM_2":"","INF_PINK_ITEM_3":"","INF_PINK_ITEM_4":""}